<template>
  <div class="ny">
    <div class="main">
      <div class="ny_bt1 mh md20">
        <span class="bt left">修改救助申请</span>
      </div>
      <el-form ref="jzForm" :rules="rules" :model="jzForm" class="mh">
        <div class="mh">
          <div class="ny_xbt1 mh md15">
            <span class="bt left">亲体移植受者申请表信息</span>
          </div>
          <ul class="jzform">
            <li>
              <span class="s_name"><font class="zt_r">*</font>受者姓名</span>
              <el-form-item prop="PatientName">
                <el-input
                  v-model="jzForm.PatientName"
                  placeholder=""
                ></el-input>
              </el-form-item>
            </li>
            <li>
              <span class="s_name"><font class="zt_r">*</font>性别</span>
              <el-form-item prop="Gender">
                <el-radio-group v-model="jzForm.Gender">
                  <el-radio label="男"></el-radio>
                  <el-radio label="女"></el-radio>
                </el-radio-group>
              </el-form-item>
            </li>
            <li>
              <span class="s_name"><font class="zt_r">*</font>出生日期</span>
              <el-form-item prop="Birthday">
                <el-date-picker
                  v-model="jzForm.Birthday"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  class="input_block"
                  @change="selectTime"
                >
                </el-date-picker>
              </el-form-item>
            </li>
            <li>
              <span class="s_name"><font class="zt_r">*</font>年龄</span>
              <el-form-item>
                <el-input v-model="jzForm.Age" :disabled="true"></el-input>
              </el-form-item>
            </li>
            <li>
              <span class="s_name"><font class="zt_r">*</font>移植选项</span>
              <el-form-item prop="TransplantType">
                <el-select
                  v-model="jzForm.TransplantType"
                  @change="selectTransplantType"
                  class="input_block"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in TransplantType_options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                prop="TransplantContent"
                style="margin-top: 10px"
                v-show="jzForm.TransplantType === 3"
              >
                <el-input
                  v-model="jzForm.TransplantContent"
                  placeholder=""
                ></el-input>
              </el-form-item>
            </li>
            <li>
              <span class="s_name"><font class="zt_r">*</font>病情简述</span>
              <el-form-item prop="Illness">
                <el-input v-model="jzForm.Illness" placeholder=""></el-input>
              </el-form-item>
            </li>
            <li>
              <span class="s_name"><font class="zt_r">*</font>联系人</span>
              <el-form-item prop="Contacts">
                <el-input v-model="jzForm.Contacts" placeholder=""></el-input>
              </el-form-item>
            </li>
            <li>
              <span class="s_name"><font class="zt_r">*</font>医保类型</span>
              <el-form-item prop="InsuranceCategory">
                <el-input
                  v-model="jzForm.InsuranceCategory"
                  placeholder=""
                ></el-input>
              </el-form-item>
            </li>
            <li>
              <span class="s_name"><font class="zt_r">*</font>联系电话</span>
              <el-form-item prop="ContactsPhone">
                <el-input
                  v-model="jzForm.ContactsPhone"
                  placeholder=""
                ></el-input>
              </el-form-item>
            </li>
            <li>
              <span class="s_name"><font class="zt_r">*</font>通信地址</span>
              <div class="sel_k">
                <div class="sel_item">
                  <el-form-item prop="Province">
                    <el-select
                      v-model="jzForm.Province"
                      filterable
                      size="small"
                      @change="selectProvinceFun($event)"
                      placeholder="请选择省份"
                      class="input_block"
                    >
                      <el-option value="" label="请选择省份"></el-option>
                      <el-option
                        :value="item"
                        :label="item.label"
                        v-for="(item, index) in city"
                        :key="index"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="sel_item">
                  <el-form-item prop="City">
                    <el-select
                      v-model="jzForm.City"
                      filterable
                      size="small"
                      @change="selectCityFun($event)"
                      placeholder="请选择城市"
                      class="input_block"
                    >
                      <el-option value="" label="请选择城市"></el-option>
                      <el-option
                        :value="item"
                        :label="item.label"
                        v-for="(item, index) in cityList"
                        :key="index"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="sel_item" style="padding-right: 0">
                  <el-form-item prop="District">
                    <el-select
                      v-model="jzForm.District"
                      filterable
                      size="small"
                      @change="selectAreaFun($event)"
                      placeholder="请选择区县"
                      class="input_block"
                    >
                      <el-option value="" label="请选择区县"></el-option>
                      <el-option
                        :value="item"
                        :label="item.label"
                        v-for="(item, index) in areaList"
                        :key="index"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="sel_item2">
                  <el-form-item prop="Address">
                    <el-input
                      v-model="jzForm.Address"
                      placeholder=""
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
            </li>
            <li>
              <span class="s_name">邮箱地址</span>
              <el-form-item prop="Email">
                <el-input v-model="jzForm.Email"></el-input>
              </el-form-item>
            </li>
            <li>
              <span class="s_name"
                ><font class="zt_r">*</font>受者身份证号码</span
              >
              <el-form-item prop="IdentityCard">
                <el-input
                  v-model="jzForm.IdentityCard"
                  placeholder=""
                ></el-input>
              </el-form-item>
            </li>
            <li>
              <span class="s_name">主治医生</span>
              <el-form-item>
                <el-select
                  v-model="jzForm.DoctorId"
                  class="input_block"
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in hz_zzys_options"
                    :key="item.DoctorId"
                    :label="item.DoctorName"
                    :value="item.DoctorId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </li>
            <li>
              <span class="s_name"><font class="zt_r">*</font>户口所在地</span>
              <div class="sel_k_2">
                <div class="sel_item">
                  <el-form-item prop="HouseholdProvince">
                    <el-select
                      v-model="jzForm.HouseholdProvince"
                      filterable
                      size="small"
                      @change="selectProvinceFun2($event)"
                      placeholder="请选择省份"
                      class="input_block"
                    >
                      <el-option value="" label="请选择省份"></el-option>
                      <el-option
                        :value="item"
                        :label="item.label"
                        v-for="(item, index) in city"
                        :key="index"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="sel_item" style="padding-right: 0">
                  <el-form-item prop="HouseholdCity">
                    <el-select
                      v-model="jzForm.HouseholdCity"
                      filterable
                      size="small"
                      @change="selectCityFun2($event)"
                      placeholder="请选择城市"
                      class="input_block"
                    >
                      <el-option value="" label="请选择城市"></el-option>
                      <el-option
                        :value="item"
                        :label="item.label"
                        v-for="(item, index) in cityList"
                        :key="index"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
            </li>
          </ul>
          <div class="ny_xbt1 mh md20">
            <span class="bt left">附件上传</span>
          </div>
          <div class="ny_xbt2 mh md20">
            <span class="bt"><font class="zt_r">*</font>亲体移植受者照片</span>
            <font class="zt_r"
              >请上传彩色照片，仅支持：jpg、png格式文件，文件大小限制为1MB及以内。</font
            >
          </div>
          <div class="mh fjsc an_qyx md40">
            <el-upload
              class="upload-demo"
              :action="uploadurl"
              :accept="'image/*'"
              :headers="headers"
              :before-upload="beforeUpload"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :before-remove="beforeRemove"
              :on-success="handleSuc"
              multiple
              :limit="10"
              :on-exceed="handleExceed"
              :file-list="files"
            >
              <el-button size="small" type="primary">新增+</el-button>
            </el-upload>
          </div>
        </div>
        <div class="mh">
          <!-- 亲体移植供者申请信息 -->
          <div class="ny_xbt1 mh md15">
            <span class="bt left">亲体移植供者申请信息</span>
          </div>
          <ul class="jzform">
            <li>
              <span class="s_name"><font class="zt_r">*</font>供者姓名</span>
              <el-form-item prop="ProviderName">
                <el-input v-model="jzForm.ProviderName"></el-input>
              </el-form-item>
            </li>
            <li>
              <span class="s_name"><font class="zt_r">*</font>性别</span>
              <el-form-item prop="ProviderGender">
                <el-radio-group v-model="jzForm.ProviderGender">
                  <el-radio label="男"></el-radio>
                  <el-radio label="女"></el-radio>
                </el-radio-group>
              </el-form-item>
            </li>
            <li>
              <span class="s_name"><font class="zt_r">*</font>出生日期</span>
              <el-form-item prop="ProviderBirthday">
                <el-date-picker
                  v-model="jzForm.ProviderBirthday"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  class="input_block"
                  @change="selectTime_gz"
                >
                </el-date-picker>
              </el-form-item>
            </li>
            <li>
              <span class="s_name"><font class="zt_r">*</font>年龄</span>
              <el-form-item>
                <el-input
                  v-model="jzForm.ProviderAge"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </li>

            <li>
              <span class="s_name"
                ><font class="zt_r">*</font>供者身份证号码</span
              >
              <el-form-item prop="ProviderIdCard">
                <el-input v-model="jzForm.ProviderIdCard"></el-input>
              </el-form-item>
            </li>
            <li>
              <span class="s_name"><font class="zt_r">*</font>医保类型</span>
              <el-form-item prop="ProviderInsuranceCategory">
                <el-input
                  v-model="jzForm.ProviderInsuranceCategory"
                  placeholder=""
                ></el-input>
              </el-form-item>
            </li>
            <li>
              <span class="s_name"><font class="zt_r">*</font>联系人</span>
              <el-form-item prop="ProviderContacts">
                <el-input
                  v-model="jzForm.ProviderContacts"
                  placeholder=""
                ></el-input>
              </el-form-item>
            </li>
            <li>
              <span class="s_name"><font class="zt_r">*</font>与受者关系</span>
              <el-form-item prop="ProviderRelation">
                <el-input v-model="jzForm.ProviderRelation"></el-input>
              </el-form-item>
            </li>

            <li>
              <span class="s_name"><font class="zt_r">*</font>联系电话</span>
              <el-form-item prop="ProviderContactsPhone">
                <el-input
                  v-model="jzForm.ProviderContactsPhone"
                  placeholder=""
                ></el-input>
              </el-form-item>
            </li>
            <li>
              <span class="s_name"><font class="zt_r">*</font>通信地址</span>
              <div class="sel_k">
                <div class="sel_item">
                  <el-form-item prop="ProviderProvince">
                    <el-select
                      v-model="jzForm.ProviderProvince"
                      filterable
                      size="small"
                      @change="selectProvinceFun_gz($event)"
                      placeholder="请选择省份"
                      class="input_block"
                    >
                      <el-option value="" label="请选择省份"></el-option>
                      <el-option
                        :value="item"
                        :label="item.label"
                        v-for="(item, index) in city"
                        :key="index"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="sel_item">
                  <el-form-item prop="ProviderCity">
                    <el-select
                      v-model="jzForm.ProviderCity"
                      filterable
                      size="small"
                      @change="selectCityFun_gz($event)"
                      placeholder="请选择城市"
                      class="input_block"
                    >
                      <el-option value="" label="请选择城市"></el-option>
                      <el-option
                        :value="item"
                        :label="item.label"
                        v-for="(item, index) in cityList"
                        :key="index"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="sel_item" style="padding-right: 0">
                  <el-form-item prop="ProviderDistrict">
                    <el-select
                      v-model="jzForm.ProviderDistrict"
                      filterable
                      size="small"
                      @change="selectAreaFun_gz($event)"
                      placeholder="请选择区县"
                      class="input_block"
                    >
                      <el-option value="" label="请选择区县"></el-option>
                      <el-option
                        :value="item"
                        :label="item.label"
                        v-for="(item, index) in areaList"
                        :key="index"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="sel_item2">
                  <el-form-item prop="ProviderAddress">
                    <el-input
                      v-model="jzForm.ProviderAddress"
                      placeholder=""
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
            </li>
            <li>
              <span class="s_name">邮箱地址</span>
              <el-form-item>
                <el-input v-model="jzForm.ProviderEmail"></el-input>
              </el-form-item>
            </li>
          </ul>
          <div class="ny_xbt1 mh md20">
            <span class="bt left">附件上传</span>
          </div>
          <div class="ny_xbt2 mh md15">
            <span class="bt"><font class="zt_r">*</font>亲体移植供者照片</span>
            <font class="zt_r"
              >请上传彩色照片，仅支持：jpg、png格式文件，文件大小限制为1MB及以内。</font
            >
          </div>
          <div class="mh fjsc an_qyx md40">
            <el-upload
              class="upload-demo"
              :action="uploadurl"
              :accept="'image/*'"
              :headers="headers"
              :before-upload="beforeUpload"
              :on-preview="handlePreview"
              :on-remove="handleRemove_gz"
              :before-remove="beforeRemove"
              :on-success="handleSuc_gz"
              multiple
              :limit="10"
              :on-exceed="handleExceed"
              :file-list="files_gz"
            >
              <el-button size="small" type="primary">新增+</el-button>
            </el-upload>
          </div>

          <!-- 附件上传 -->
          <div class="ny_xbt1 mh md20">
            <span class="bt left">上传附件资料</span>
          </div>
          <div class="ny_xbt2 mh md15">
            <font class="zt_r">*</font
            >亲体移植受者身份证明（户口本和身份证）复印件：
            <font class="zt_r"
              >仅支持：jpg、png格式文件，文件大小限制为1MB及以内。</font
            >
          </div>
          <div class="mh fjsc an_qyx md20">
            <el-upload
              class="upload-demo"
              :action="uploadurl"
              :accept="'image/*'"
              :headers="headers"
              :before-upload="beforeUpload"
              :on-preview="handlePreview"
              :on-remove="handleRemove_Household"
              :before-remove="beforeRemove"
              :on-success="handleSuc_sqr"
              multiple
              :limit="10"
              :on-exceed="handleExceed"
              :file-list="files_Household"
            >
              <el-button size="small" type="primary">新增+</el-button>
            </el-upload>
          </div>
          <div class="ny_xbt2 mh md15">
            <font class="zt_r">*</font
            >亲体移植供者身份证明（户口本和身份证）复印件：
            <font class="zt_r"
              >仅支持：jpg、png格式文件，文件大小限制为1MB及以内。</font
            >
          </div>
          <div class="mh fjsc an_qyx md20">
            <el-upload
              class="upload-demo"
              :action="uploadurl"
              :accept="'image/*'"
              :headers="headers"
              :before-upload="beforeUpload"
              :on-preview="handlePreview"
              :on-remove="handleRemove_ParentsHousehold"
              :before-remove="beforeRemove"
              :on-success="handleSuc_jhr"
              multiple
              :limit="10"
              :on-exceed="handleExceed"
              :file-list="files_ParentsHousehold"
            >
              <el-button size="small" type="primary">新增+</el-button>
            </el-upload>
          </div>
          <div class="ny_xbt2 mh md15">
            <font class="zt_r">*</font
            >亲体移植受者化验报告：血常规、肝（肾）功能、出凝血时间、疾病诊断证明（天津市第一中心医院门诊病历或住院病例首页）：
            <font class="zt_r"
              >仅支持：jpg、png格式文件，文件大小限制为1MB及以内。</font
            >
          </div>
          <div class="mh fjsc an_qyx md20">
            <el-upload
              class="upload-demo"
              :action="uploadurl"
              :accept="'image/*'"
              :headers="headers"
              :before-upload="beforeUpload"
              :on-preview="handlePreview"
              :on-remove="handleRemove_UserSerological"
              :before-remove="beforeRemove"
              :on-success="handleSuc_hz"
              multiple
              :limit="10"
              :on-exceed="handleExceed"
              :file-list="files_UserSerological"
            >
              <el-button size="small" type="primary">新增+</el-button>
            </el-upload>
          </div>
          <div class="ny_xbt2 mh md15">
            <font class="zt_r">*</font>亲体移植受者 B 超检查结果：
            <font class="zt_r"
              >仅支持：jpg、png格式文件，文件大小限制为1MB及以内。</font
            >
          </div>
          <div class="mh fjsc an_qyx md40">
            <el-upload
              class="upload-demo"
              :action="uploadurl"
              :accept="'image/*'"
              :headers="headers"
              :before-upload="beforeUpload"
              :on-preview="handlePreview"
              :on-remove="handleRemove_UserExaminationReal"
              :before-remove="beforeRemove"
              :on-success="handleSuc_hzb"
              multiple
              :limit="10"
              :on-exceed="handleExceed"
              :file-list="files_UserExaminationReal"
            >
              <el-button size="small" type="primary">新增+</el-button>
            </el-upload>
          </div>

          <div class="suc_anq mh">
            <el-button type="primary an_r" @click="cns_save(0)">保存</el-button>
            <el-button type="primary an_r" @click="submitForm()"
              >提交申请
            </el-button>
          </div>
        </div>
      </el-form>
      <!-- 新增家庭情况 -->
      <el-dialog
        :title="jt_title"
        :visible.sync="dialogFormVisible"
        @close="closeDialog('jtform')"
      >
        <el-form :model="jtform" ref="jtform" :rules="rules">
          <el-form-item
            label="姓名："
            :label-width="formLabelWidth"
            prop="RealName"
          >
            <el-input v-model="jtform.RealName" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item
            label="关系："
            :label-width="formLabelWidth"
            prop="Relation"
          >
            <el-input
              v-model="jtform.Relation"
              onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"
              maxlength="2"
              show-word-limit
            ></el-input>
          </el-form-item>

          <el-form-item label="年龄：" :label-width="formLabelWidth" prop="Age">
            <el-input v-model="jtform.Age" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item
            label="职业："
            :label-width="formLabelWidth"
            prop="Occupation"
          >
            <el-select
              v-model="jtform.Occupation"
              placeholder="请选择"
              class="sel1"
            >
              <el-option
                v-for="item in Occupation_options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="jt_form_tj(zsm, row_index)"
            >确 定
          </el-button>
        </div>
      </el-dialog>
      <!--查看承诺书-->
      <el-dialog
        title="承诺书"
        :visible.sync="dialogVisible_cns"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        width="500px"
        :center="true"
        @opened="cns_submit"
        @closed="cns_save(1)"
      >
        <div>
          <p style="text-indent: 2em">
            因患者接受基金会捐赠，出院后将原始住院收费票据交付天津市华
            夏器官移植救助基金会留存。以上申请资料中如出现虚假、伪造或隐瞒等
            行为，一经发现，患者将失去接受资助资格；如已获资助，依法返还所获
            得的全部资助款。
          </p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="info" v-show="!dl_submit"
            >{{ dl_second }}秒后可关闭</el-button
          >
          <el-button
            type="primary"
            @click="dialogVisible_cns = false"
            v-if="dl_submit"
            >我已确定并提交</el-button
          >
        </span>
      </el-dialog>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
import http from "../../http/http";
import api from "../../http/api";
import city from "@/assets/json/city.json";
import {
  hz_jfqtyz_options,
  Occupation_options,
  Relation_options,
  Nation_options,
  TransplantType_options,
} from "@/assets/js/sqfrom";
export default {
  data() {
    var checkEmail = (rule, value, callback) => {
      const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
      setTimeout(() => {
        if (mailReg.test(value)) {
          callback();
        } else {
          callback(new Error("请输入正确的邮箱格式"));
        }
      }, 100);
    };
    var TransplantContent_val = (rule, value, callback) => {
      if (value === "" && this.jzForm.TransplantType === 3) {
        callback(new Error("请输入"));
      } else {
        callback();
      }
    };
    return {
      dialogVisible_cns: false,
      dl_submit: false,
      dl_second: 10,
      spData: [],
      uploadurl: this.GLOBAL.posturl + "api/account/uploadpic?UserId="+localStorage.getItem('UserId'),
      //   path_show: 1, //流程切换
      TransplantName: "",
      TransplantRelation: "",
      TransplantGender: "",
      TransplantAge: "",
      hz_jfqtyz_options,
      Occupation_options,
      Relation_options,
      Nation_options,
      TransplantType_options,
      hz_zzys_options: [],
      hz_zzys_optionsbak: [],
      jtform: {
        RealName: "",
        Relation: "",
        Age: "",
        Occupation: "",
      },
      jzForm: {
        UserId: this.$route.query.UserId,
        ApplyId: this.$route.query.ApplyId,
        PatientName: "",
        Gender: "",
        Age: "",
        Birthday: "",
        Illness: "",
        TransplantType: "",
        TransplantContent: "",
        Contacts: "",
        InsuranceCategory: "",
        ContactsPhone: "",
        Province: "",
        City: "",
        District: "",
        Address: "",
        Email: "",
        IdentityCard: "",
        DoctorId: "",
        HouseholdProvince: "",
        HouseholdCity: "",
        ProviderName: "",
        ProviderGender: "",
        ProviderBirthday: "",
        ProviderAge: "",
        ProviderIdCard: "",
        ProviderInsuranceCategory: "",
        ProviderContacts: "",
        ProviderContactsPhone: "",
        ProviderRelation: "",
        ProviderProvince: "",
        ProviderCity: "",
        ProviderDistrict: "",
        ProviderAddress: "",
        ProviderEmail: "",
        UserRealNamePic: "",
        UserSaveNamePic: "",
        DonorRealNamePic: "",
        DonorSaveNamePic: "",
        UserHouseholdRealNamePic: "",
        UserHouseholdSaveNamePic: "",
        ParentsHouseholdRealNamePic: "",
        ParentsHouseholdSaveNamePic: "",
        UserSerologicalRealNamePic: "",
        UserSerologicalSaveNamePic: "",
        UserExaminationRealNamePic: "",
        UserExaminationSaveNamePic: "",
      },
      hz_cnsqr: "",
      rules: {
        PatientName: [
          { required: true, message: "请输入受者姓名", trigger: "blur" },
        ],
        Gender: [{ required: true, message: "请选择性别", trigger: "change" }],
        Birthday: [
          { required: true, message: "请输入出生日期", trigger: "blur" },
        ],
        Illness: [
          { required: true, message: "请输入病情简述", trigger: "blur" },
        ],
        Contacts: [
          { required: true, message: "请输入联系人", trigger: "blur" },
        ],
        InsuranceCategory: [
          { required: true, message: "请输入与医保类型", trigger: "blur" },
        ],
        ContactsPhone: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
        ],
        Province: [{ required: true, message: " ", trigger: "change" }],
        City: [{ required: true, message: " ", trigger: "change" }],
        District: [{ required: true, message: " ", trigger: "change" }],
        Address: [
          { required: true, message: "请输入详细地址", trigger: "blur" },
        ],
        IdentityCard: [
          { required: true, message: "请输入受者身份证号码", trigger: "blur" },
          {
            min: 15,
            max: 18,
            message: "请输入有效的身份证号",
            trigger: "blur",
          },
          {
            required: true,
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: "请输入有效的身份证号",
            trigger: "blur",
          },
        ],
        TransplantType: [
          { required: true, message: "请选择移植选项", trigger: "change" },
        ],
        TransplantContent: [
          { validator: TransplantContent_val, trigger: "blur" },
        ],
        HouseholdProvince: [
          { required: true, message: " ", trigger: "change" },
        ],
        HouseholdCity: [{ required: true, message: " ", trigger: "change" }],
        ProviderName: [
          { required: true, message: "请输入供者姓名", trigger: "blur" },
        ],
        ProviderGender: [
          { required: true, message: "请选择性别", trigger: "change" },
        ],
        ProviderBirthday: [
          { required: true, message: "请输入出生日期", trigger: "blur" },
        ],

        ProviderIdCard: [
          { required: true, message: "请输入供者身份证号码", trigger: "blur" },
          {
            min: 15,
            max: 18,
            message: "请输入有效的身份证号",
            trigger: "blur",
          },
          {
            required: true,
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: "请输入有效的身份证号",
            trigger: "blur",
          },
        ],
        ProviderContacts: [
          { required: true, message: "请输入联系人", trigger: "blur" },
        ],
        ProviderRelation: [
          { required: true, message: "请输入与受者关系", trigger: "blur" },
        ],
        ProviderInsuranceCategory: [
          { required: true, message: "请输入与医保类型", trigger: "blur" },
        ],
        ProviderContactsPhone: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
        ],
        ProviderProvince: [{ required: true, message: " ", trigger: "change" }],
        ProviderCity: [{ required: true, message: " ", trigger: "change" }],
        ProviderDistrict: [{ required: true, message: " ", trigger: "change" }],
        ProviderAddress: [
          { required: true, message: "请输入详细地址", trigger: "blur" },
        ],
      },
      zsm: 1,
      row_index: "",
      imageIndex: -1, // 附件index
      fileList: [],
      fileList_hz: [],
      fileList_gz: [],
      fileList_Household: [],
      fileList_ParentsHousehold: [],
      fileList_UserSerological: [],
      fileList_UserExaminationReal: [],
      files: [],
      files_hz: [],
      files_gz: [],
      files_Household: [],
      files_ParentsHousehold: [],
      files_UserSerological: [],
      files_UserExaminationReal: [],
      // 整个省市县数据
      city: city,
      // 被选中的市数据
      cityList: [],
      // 被选中的县数据
      areaList: [],
      tableData: [],
      dialogFormVisible: false,
      jt_title: "",
      jtform: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },
      formLabelWidth: "80px",
      UserRealNamePic: [],
      headers: {
        Authorization: "Bearer " + this.$myStore.state.token,
      },
    };
  },
  mounted() {
    //初始化主治医生
    // this.DoctorIdData();
    this.DetailData();
  },
  methods: {
      //null判断返回空字符串
    nullAssign(val) {
      if (val == null) {
        return "";
      } else {
        return val;
      }
    },
    //载入数据
    DetailData: async function () {
      let params = {
        UserId: this.$route.query.UserId,
        ApplyId: this.$route.query.ApplyId,
      };
      const res = await http.get(api.apigetdetail, params);
      this.jzForm = res.data.obj;
      // console.log(this.jzForm);
      this.jzForm.Gender = this.nullAssign(this.jzForm.Gender);
      this.jzForm.Province = this.nullAssign(this.jzForm.Province);
      this.jzForm.City = this.nullAssign(this.jzForm.City);
      this.jzForm.District = this.nullAssign(this.jzForm.District);
      this.jzForm.HouseholdProvince = this.nullAssign(this.jzForm.HouseholdProvince);
      this.jzForm.HouseholdCity = this.nullAssign(this.jzForm.HouseholdCity);
      this.jzForm.ProviderGender = this.nullAssign(this.jzForm.ProviderGender);
      this.jzForm.ProviderProvince = this.nullAssign(this.jzForm.ProviderProvince);
      this.jzForm.ProviderCity = this.nullAssign(this.jzForm.ProviderCity);
      this.jzForm.ProviderDistrict = this.nullAssign(this.jzForm.ProviderDistrict);
      if(this.jzForm.DoctorId == 0){
         this.jzForm.DoctorId=''
      }
      this.DoctorIdData(res.data.obj.TransplantType);
      if (res.data.obj.UserRealNamePic != "") {
        this.fileList = this.upload_ayy(
          res.data.obj.UserRealNamePic,
          res.data.obj.UserSaveNamePic
        );
        this.files = this.upload_ayy(
          res.data.obj.UserRealNamePic,
          res.data.obj.UserSaveNamePic
        );
        // console.log(this.fileList);
      }
      if (res.data.obj.DonorRealNamePic != "") {
        this.fileList_gz = this.upload_ayy(
          res.data.obj.DonorRealNamePic,
          res.data.obj.DonorSaveNamePic
        );
        this.files_gz = this.upload_ayy(
          res.data.obj.DonorRealNamePic,
          res.data.obj.DonorSaveNamePic
        );
      }
      if (res.data.obj.UserHouseholdRealNamePic != "") {
        this.fileList_Household = this.upload_ayy(
          res.data.obj.UserHouseholdRealNamePic,
          res.data.obj.UserHouseholdSaveNamePic
        );
        this.files_Household = this.upload_ayy(
          res.data.obj.UserHouseholdRealNamePic,
          res.data.obj.UserHouseholdSaveNamePic
        );
      }
      if (res.data.obj.ParentsHouseholdRealNamePic != "") {
        this.fileList_ParentsHousehold = this.upload_ayy(
          res.data.obj.ParentsHouseholdRealNamePic,
          res.data.obj.ParentsHouseholdSaveNamePic
        );
        this.files_ParentsHousehold = this.upload_ayy(
          res.data.obj.ParentsHouseholdRealNamePic,
          res.data.obj.ParentsHouseholdSaveNamePic
        );
      }
      if (res.data.obj.UserSerologicalRealNamePic != "") {
        this.fileList_UserSerological = this.upload_ayy(
          res.data.obj.UserSerologicalRealNamePic,
          res.data.obj.UserSerologicalSaveNamePic
        );
        this.files_UserSerological = this.upload_ayy(
          res.data.obj.UserSerologicalRealNamePic,
          res.data.obj.UserSerologicalSaveNamePic
        );
      }
      if (res.data.obj.UserExaminationRealNamePic != "") {
        this.fileList_UserExaminationReal = this.upload_ayy(
          res.data.obj.UserExaminationRealNamePic,
          res.data.obj.UserExaminationSaveNamePic
        );
        this.files_UserExaminationReal = this.upload_ayy(
          res.data.obj.UserExaminationRealNamePic,
          res.data.obj.UserExaminationSaveNamePic
        );
      }
    },
    //图片上传前
    beforeUpload(file) {
      let _this = this;
      return new Promise((resolve, reject) => {
        let isLt2M = file.size / 1024 / 1024 < 10; // 判定图片大小是否小于10MB
        if (!isLt2M) {
          reject();
        }
        let image = new Image(),
          resultBlob = "";
        image.src = URL.createObjectURL(file);
        image.onload = () => {
          // 调用方法获取blob格式，方法写在下边
          resultBlob = _this.compressUpload(image, file);
          resolve(resultBlob);
        };
        image.onerror = () => {
          reject();
        };
      });
    },
    /* 图片压缩方法-canvas压缩 */
    compressUpload(image, file) {
      let canvas = document.createElement("canvas");
      let ctx = canvas.getContext("2d");
      let initSize = image.src.length;
      let { width } = image,
        { height } = image;
      canvas.width = width;
      canvas.height = height;
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(image, 0, 0, width, height);

      // 进行最小压缩0.1
      let compressData = canvas.toDataURL(file.type || "image/jpeg", 0.2);

      // 压缩后调用方法进行base64转Blob，方法写在下边
      let blobImg = this.dataURItoBlob(compressData);
      return blobImg;
    },

    /* base64转Blob对象 */
    dataURItoBlob(data) {
      let byteString;
      if (data.split(",")[0].indexOf("base64") >= 0) {
        byteString = atob(data.split(",")[1]);
      } else {
        byteString = unescape(data.split(",")[1]);
      }
      let mimeString = data.split(",")[0].split(":")[1].split(";")[0];
      let ia = new Uint8Array(byteString.length);
      for (let i = 0; i < byteString.length; i += 1) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ia], { type: mimeString });
    },
    //获取主治医生
    DoctorIdData: async function (TraType) {
      let params = {
        UserId: localStorage.getItem("UserId"),
        TransplantType: TraType,
      };
      const res = await http.get(api.apigetdoctorlist, params);
      this.hz_zzys_options = res.data.obj;
      // console.log(res.data.obj);
      // console.log(this.hz_zzys_options);
    },
    //按类型获取主治医生
    selectTransplantType(value) {
      // console.log(value)
      this.hz_zzys_options = this.hz_zzys_optionsbak;
      this.jzForm.DoctorId = "";
      this.DoctorIdData(value);
    },
    //附件取值
    upload_value(name_name, type_name) {
      var val = "";
      if (type_name == "name") {
        for (var i = 0; i < name_name.length; i++) {
          val += name_name[i].name + "|";
        }
      } else {
        for (var i = 0; i < name_name.length; i++) {
          val += name_name[i].url + "|";
        }
      }
      return val;
    },
    //年龄赋值
    selectTime(val) {
      if (val) {
        this.jzForm.Age = this.getage(val);
      }
    },
    //供者年龄赋值
    selectTime_gz(val) {
      if (val) {
        this.jzForm.ProviderAge = this.getage(val);
      }
    },
    //年龄
    getage(a) {
      let birthdays = new Date(a);
      let d = new Date();
      let age =
        d.getFullYear() -
        birthdays.getFullYear() -
        (d.getMonth() < birthdays.getMonth() ||
        (d.getMonth() == birthdays.getMonth() &&
          d.getDate() < birthdays.getDate())
          ? 1
          : 0);
      return age;
    },
    //附件转化成数组
    upload_ayy(name, url) {
      var val = [];
      var val_name = name.split("|");
      var val_url = url.split("|");
      for (var i = 0; i < val_name.length; i++) {
        val.push({
          name: val_name[i],
          url: val_url[i],
        });
      }
      // console.log(val);
      return val;
    },
    //提交申请
    async submitForm() {
      this.$refs.jzForm.validate((valid) => {
        if (valid) {
          if (this.jzForm.DoctorId == "") {
            this.jzForm.DoctorId = 0;
          }
          this.jzForm.UserRealNamePic = this.upload_value(
            this.fileList,
            "name"
          );
          this.jzForm.UserSaveNamePic = this.upload_value(this.fileList, "url");

            this.jzForm.DonorRealNamePic = this.upload_value(
            this.fileList_gz,
            "name"
          );
          this.jzForm.DonorSaveNamePic = this.upload_value(this.fileList_gz, "url");

          this.jzForm.UserHouseholdRealNamePic = this.upload_value(
            this.fileList_Household,
            "name"
          );
          this.jzForm.UserHouseholdSaveNamePic = this.upload_value(
            this.fileList_Household,
            "url"
          );
          this.jzForm.ParentsHouseholdRealNamePic = this.upload_value(
            this.fileList_ParentsHousehold,
            "name"
          );
          this.jzForm.ParentsHouseholdSaveNamePic = this.upload_value(
            this.fileList_ParentsHousehold,
            "url"
          );
          this.jzForm.UserSerologicalRealNamePic = this.upload_value(
            this.fileList_UserSerological,
            "name"
          );
          this.jzForm.UserSerologicalSaveNamePic = this.upload_value(
            this.fileList_UserSerological,
            "url"
          );
          this.jzForm.UserExaminationRealNamePic = this.upload_value(
            this.fileList_UserExaminationReal,
            "name"
          );
          this.jzForm.UserExaminationSaveNamePic = this.upload_value(
            this.fileList_UserExaminationReal,
            "url"
          );
          let data = this.jzForm;
          // console.log(data);
          if (this.jzForm.UserRealNamePic == "") {
              return this.$message.error("请上传亲体移植受者照片");
           }else if (this.jzForm.DonorRealNamePic == "") {
            return this.$message.error("请上传亲体移植供者照片");
          } else if (this.jzForm.UserHouseholdRealNamePic == "") {
            return this.$message.error("请上传亲体移植受者身份证明");
          } else if (this.jzForm.ParentsHouseholdRealNamePic == "") {
            return this.$message.error("请上传亲体移植供者身份证明");
          } else if (this.jzForm.UserSerologicalRealNamePic == "") {
            return this.$message.error("请上传亲体移植受者化验报告");
          } else if (this.jzForm.UserExaminationRealNamePic == "") {
            return this.$message.error("请上传亲体移植受者 B 超检查结果");
          } else {
            this.dialogVisible_cns = true;
          }
        } else {
          setTimeout(() => {
            var isError = document.getElementsByClassName("is-error");
            isError[0].querySelector("input").focus();
          }, 100);
          return false;
        }
      });
    },
    cns_submit() {
      this.dl_second = 10;
      this.dl_seconds = setInterval(() => {
        this.dl_second--;
        if (this.dl_second === 0) {
          this.dl_submit = true;
          clearInterval(this.dl_seconds);
        }
      }, 1000);
    },
    cns_save(n) {
      if (this.jzForm.PatientName == "") {
        return this.$message.error("受者姓名不能为空！");
      }
      if (this.jzForm.TransplantType == "") {
        return this.$message.error("请选择移植选项！");
      }
      this.jzForm.SumbitStatus = n;
      this.jzForm.UserRealNamePic = this.upload_value(this.fileList, "name");
      this.jzForm.UserSaveNamePic = this.upload_value(this.fileList, "url");
          this.jzForm.DonorRealNamePic = this.upload_value(
            this.fileList_gz,
            "name"
          );
          this.jzForm.DonorSaveNamePic = this.upload_value(this.fileList_gz, "url");
      this.jzForm.UserHouseholdRealNamePic = this.upload_value(
        this.fileList_Household,
        "name"
      );
      this.jzForm.UserHouseholdSaveNamePic = this.upload_value(
        this.fileList_Household,
        "url"
      );
      this.jzForm.ParentsHouseholdRealNamePic = this.upload_value(
        this.fileList_ParentsHousehold,
        "name"
      );
      this.jzForm.ParentsHouseholdSaveNamePic = this.upload_value(
        this.fileList_ParentsHousehold,
        "url"
      );
      this.jzForm.UserSerologicalRealNamePic = this.upload_value(
        this.fileList_UserSerological,
        "name"
      );
      this.jzForm.UserSerologicalSaveNamePic = this.upload_value(
        this.fileList_UserSerological,
        "url"
      );
      this.jzForm.UserExaminationRealNamePic = this.upload_value(
        this.fileList_UserExaminationReal,
        "name"
      );
      this.jzForm.UserExaminationSaveNamePic = this.upload_value(
        this.fileList_UserExaminationReal,
        "url"
      );
      let data = this.jzForm;
      http.post(api.apieditapply, data).then(
        (res) => {
          if (res.data.Status == 1) {
            if (n > 0) {
              this.$message.success(res.data.Message);
              this.$router.push({ path: "/user/usersuc_sq3" });
            } else {
              // this.jzForm.ApplyId = res.data.obj;
              this.$message.success("保存成功");
            }
          } else {
            return this.$message.error(res.data.Message);
          }
        },
        (error) => {
          console.log(err);
        }
      );
    },
    // 省份 市 县联动
    selectProvinceFun(event) {
      // console.log(event);
      if (event) {
        this.cityList = event.children;
      } else {
        this.cityList = [];
      }
      this.areaList = [];
      this.jzForm.Province = event.label;
      // this.$emit("getLawyerListInfo", [event.label, "province"]);
    },
    selectCityFun(event) {
      // console.log(event);
      if (event) {
        this.areaList = event.children;
      } else {
        this.areaList = [];
      }
      this.jzForm.City = event.label;
    },
    selectAreaFun(event) {
      // console.log(event);
      // this.$emit("getLawyerListInfo", [event.label, "area"]);
      this.jzForm.District = event.label;
    },
    //户口所在地 省份 市联动
    selectProvinceFun2(event) {
      if (event) {
        this.cityList = event.children;
      } else {
        this.cityList = [];
      }
      this.areaList = [];
      this.jzForm.HouseholdProvince = event.label;
    },
    selectCityFun2(event) {
      if (event) {
        this.areaList = event.children;
      } else {
        this.areaList = [];
      }
      this.jzForm.HouseholdCity = event.label;
    },
    //供者通信地址 省份 市 县联动
    selectProvinceFun_gz(event) {
      if (event) {
        this.cityList = event.children;
      } else {
        this.cityList = [];
      }
      this.areaList = [];
      this.jzForm.ProviderProvince = event.label;
      // this.$emit("getLawyerListInfo", [event.label, "province"]);
    },
    selectCityFun_gz(event) {
      if (event) {
        this.areaList = event.children;
      } else {
        this.areaList = [];
      }
      this.jzForm.ProviderCity = event.label;
    },
    selectAreaFun_gz(event) {
      this.jzForm.ProviderDistrict = event.label;
    },

    handlePreview(file) {
      if (file.hasOwnProperty("response")) {
        this.$alert(
          '<div class="picyl"><img src="' +
            file.response.obj[0].FileUrl +
            '"></div>',
          "",
          {
            confirmButtonText: "关闭",
            dangerouslyUseHTMLString: true,
          }
        );
      } else {
        this.$alert(
          '<div class="picyl"><img src="' + file.url + '"></div>',
          "",
          {
            confirmButtonText: "关闭",
            dangerouslyUseHTMLString: true,
          }
        );
      }
      // console.log(file);
    },
    onBeforeUpload(file) {
      const isIMAGE = file.type === "image/jpeg" || "image/jpg" || "image/png";
      // const isLt1M = file.size / 1024 / 1024 < 1;
      if (!isIMAGE) {
        this.$message.error("上传文件只能是图片格式!");
      }
      // if (!isLt1M) {
      //   this.$message.error("上传文件大小不能超过 1MB!");
      // }
      // return isIMAGE && isLt1M;
      return isIMAGE;
    },
    //受者
    handleSuc(file, fileList) {
      // console.log(file);
      // console.log(fileList);
      // this.UserRealNamePic += file.obj[0].FileName + "|";
      // this.UserSaveNamePic += file.obj[0].FileUrl + "|";
      // let obj_new={
      //   name: file.obj[0].FileName,
      //   url: file.obj[0].FileUrl,
      // }
      // this.fileList.push(obj_new);
      this.fileList.push({
        name: file.obj[0].FileName,
        url: file.obj[0].FileUrl,
      });
      // this.files.push({
      //   name: fileList.response.obj[0].FileName,
      //   status: fileList.status,
      //   uid: fileList.uid,
      //   url: fileList.response.obj[0].FileUrl,
      // });

    },
    //供者
    handleSuc_gz(file, fileList) {
      // console.log(file);
      // this.UserRealNamePic += file.obj[0].FileName + "|";
      // this.UserSaveNamePic += file.obj[0].FileUrl + "|";
      this.fileList_gz.push({
        name: file.obj[0].FileName,
        url: file.obj[0].FileUrl,
      });
      // console.log(file);
      //  console.log(this.fileList);
    },
    //申请人
    handleSuc_sqr(file, fileList) {
      // this.UserHouseholdRealNamePic += file.obj[0].FileName + "|";
      // this.UserHouseholdSaveNamePic += file.obj[0].FileUrl + "|";
      this.fileList_Household.push({
        name: file.obj[0].FileName,
        url: file.obj[0].FileUrl,
      });
    },
    //监护人
    handleSuc_jhr(file, fileList) {
      // this.ParentsHouseholdRealNamePic += file.obj[0].FileName + "|";
      // this.ParentsHouseholdSaveNamePic += file.obj[0].FileUrl + "|";
      this.fileList_ParentsHousehold.push({
        name: file.obj[0].FileName,
        url: file.obj[0].FileUrl,
      });
    },
    //检查报告
    handleSuc_hz(file, fileList) {
      // this.UserSerologicalRealNamePic += file.obj[0].FileName + "|";
      // this.UserSerologicalSaveNamePic += file.obj[0].FileUrl + "|";
      this.fileList_UserSerological.push({
        name: file.obj[0].FileName,
        url: file.obj[0].FileUrl,
      });
    },
    //B超
    handleSuc_hzb(file, fileList) {
      // this.UserExaminationRealNamePic += file.obj[0].FileName + "|";
      // this.UserExaminationSaveNamePic += file.obj[0].FileUrl + "|";
      this.fileList_UserExaminationReal.push({
        name: file.obj[0].FileName,
        url: file.obj[0].FileUrl,
      });
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 10 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      // fileList.forEach(function(imgitem,index){
      //   console.log("fileList:"+imgitem.uid);
      // });
      this.imageIndex = fileList.findIndex((fileItem) => {
        return fileItem.uid === file.uid;
      });
      //console.log(this.imageIndex);
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    //上传删除
    handleRemove(file, fileList) {
      //let index = fileList.findIndex(item => item === file.uid);
      if (this.imageIndex > -1) {
        this.fileList.splice(this.imageIndex, 1);
      }
    },
    //上传删除 供者
    handleRemove_gz(file, fileList) {
      //let index = fileList.findIndex(item => item === file.uid);
      if (this.imageIndex > -1) {
        this.fileList_gz.splice(this.imageIndex, 1);
      }
    },
    handleRemove_Household(file, fileList) {
      // let index = fileList.findIndex(item => item === file.uid);
      // this.fileList_Household.splice(index, 1);
      if (this.imageIndex > -1) {
        this.fileList_Household.splice(this.imageIndex, 1);
      }
    },
    handleRemove_ParentsHousehold(file, fileList) {
      // let index = fileList.findIndex(item => item === file.uid);
      // // fileList.splice(index, 1);
      // this.fileList_ParentsHousehold.splice(index, 1);
      if (this.imageIndex > -1) {
        this.fileList_ParentsHousehold.splice(this.imageIndex, 1);
      }
    },
    handleRemove_UserSerological(file, fileList) {
      // let index = fileList.findIndex(item => item === file.uid);
      // // fileList.splice(index, 1);
      // this.fileList_UserSerological.splice(index, 1);
      if (this.imageIndex > -1) {
        this.fileList_UserSerological.splice(this.imageIndex, 1);
      }
    },
    handleRemove_UserExaminationReal(file, fileList) {
      // let index = fileList.findIndex(item => item === file.uid);
      // // fileList.splice(index, 1);
      // this.fileList_UserExaminationReal.splice(index, 1);
      if (this.imageIndex > -1) {
        this.fileList_UserExaminationReal.splice(this.imageIndex, 1);
      }
    },
    //表格删除
    deleteRow(index, rows) {
      this.$confirm("请确定是否删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          rows.splice(index, 1);
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //家庭情况表单提交
    jt_form_tj(zsm, index) {
      let veri = 0;
      // console.log(this.jt_title);
      this.$refs.jtform.validateField("RealName", (errMsg) => {
        if (errMsg) {
          veri = 1;
        }
      });
      this.$refs.jtform.validateField("Age", (errMsg) => {
        if (errMsg) {
          veri = 1;
        }
      });
      this.$refs.jtform.validateField("Relation", (errMsg) => {
        if (errMsg) {
          veri = 1;
        }
      });
      this.$refs.jtform.validateField("Occupation", (errMsg) => {
        if (errMsg) {
          veri = 1;
        }
      });
      if (veri == 0) {
        if (zsm == 1) {
          this.tableData.push({
            RealName: this.jtform.RealName,
            Relation: this.jtform.Relation,
            Age: this.jtform.Age,
            Occupation: this.jtform.Occupation,
          });
        } else {
          (this.tableData[index].RealName = this.jtform.RealName),
            (this.tableData[index].Age = this.jtform.Age),
            (this.tableData[index].Relation = this.jtform.Relation),
            (this.tableData[index].Occupation = this.jtform.Occupation);
        }
        // console.log(this.tableData);
        (this.jtform.RealName = ""),
          (this.jtform.Age = ""),
          (this.jtform.Relation = ""),
          (this.jtform.Occupation = "");
        this.dialogFormVisible = false;
      }
    },
    //关闭弹层
    closeDialog(formName) {
      (this.jtform.RealName = ""),
        (this.jtform.Age = ""),
        (this.jtform.Relation = ""),
        (this.jtform.Occupation = ""),
        (this.dialogFormVisible = false);
    },
    //新增家庭情况
    addrow() {
      this.dialogFormVisible = true;
      this.zsm = 1;
      this.jt_title = "新增家庭情况";
    },
    //编辑家庭情况
    editrow(index, rows) {
      // console.log(rows);
      this.zsm = 2;
      this.row_index = index;
      this.jt_title = "编辑家庭情况";
      this.dialogFormVisible = true;
      (this.jtform.RealName = rows[index].RealName),
        (this.jtform.Age = rows[index].Age),
        (this.jtform.Relation = rows[index].Relation),
        (this.jtform.Occupation = rows[index].Occupation);
    },
  },
  created: function () {
    // this.$emit('header', false);
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/user/userspedit.vue